module.exports = __webpack_public_path__ + "static/img/1-g.189ba111.png";